var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatSapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.992,
    height: 37,
    viewBox: "0 0 36.992 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WatSapp",
    transform: "translate(201.947 201.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WatSapp-2",
    "data-name": "WatSapp",
    transform: "translate(-201.947 -201.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10427",
    "data-name": "Group 10427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10426",
    "data-name": "Group 10426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10425",
    "data-name": "Group 10425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29382",
    "data-name": "Path 29382",
    d: "M36.984,17.565A18.164,18.164,0,0,0,.689,17.233c-.009.263-.018.527-.018.791a17.883,17.883,0,0,0,2.6,9.309L0,37l10.058-3.2a18.183,18.183,0,0,0,26.934-15.78C36.992,17.871,36.992,17.718,36.984,17.565ZM18.832,33.174a15.214,15.214,0,0,1-8.4-2.508l-5.865,1.87,1.9-5.628a15,15,0,0,1-2.907-8.885,14.042,14.042,0,0,1,.076-1.471,15.275,15.275,0,0,1,30.411.289c.035.391.052.782.052,1.182A15.227,15.227,0,0,1,18.832,33.174Z",
    fill: "#101b2d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29383",
    "data-name": "Path 29383",
    d: "M126.654,121.411a4.441,4.441,0,0,1-3,2.1c-.817.077-.817.663-5.348-1.1s-7.38-6.385-7.6-6.673a10.045,10.045,0,0,1-1.59-3.06,5.655,5.655,0,0,1-.23-1.505,4.947,4.947,0,0,1,1.556-3.69,1.648,1.648,0,0,1,1.19-.553c.3,0,.594.043.851.043s.637-.153,1,.73,1.266,3.061,1.377,3.282a.8.8,0,0,1,.035.774,5.126,5.126,0,0,1-.281.527c-.051.068-.1.136-.162.212-.23.256-.467.57-.671.774-.221.222-.45.459-.2.9a13.206,13.206,0,0,0,2.474,3.052,12.068,12.068,0,0,0,3.58,2.193c.45.221.706.187.969-.111s1.114-1.284,1.41-1.726.6-.374,1-.221,2.593,1.215,3.044,1.436.739.333.85.51a3.638,3.638,0,0,1-.263,2.1",
    transform: "translate(-98.912 -97.138)",
    fill: "#101b2d"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatSapp);
export default __webpack_public_path__ + "static/media/WatSapp.b98287330a1135264fd9181049dd1f7a.svg";
export { ForwardRef as ReactComponent };